import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';

export interface DelegationOwner {
  readonly id: string;
  readonly name: string;
  readonly isNetworkWideAudience: boolean;
}

interface DelegationState {
  readonly selectedOnBehalfOfUserId: string | undefined;
  setSelectedOnBehalfOfUserId(userId: string | undefined): void;
  readonly hasSelected: boolean;
  setHasSelected(hasSelected: boolean): void;
  readonly delegationOwners: Record<string, DelegationOwner>;
  setDelegationOwners(owners: Record<string, DelegationOwner>): void;
  readonly delegationOwnersCount: number;
  readonly isViewerDelegateOfLeaders: boolean;
}

export const useDelegationStore: UseBoundStore<StoreApi<DelegationState>> = create<DelegationState>((set) => ({
  selectedOnBehalfOfUserId: undefined,
  setSelectedOnBehalfOfUserId: (userId) => {
    set({ selectedOnBehalfOfUserId: userId });
  },
  hasSelected: false,
  setHasSelected: (hasSelected) => {
    set({ hasSelected });
  },
  delegationOwners: {},
  delegationOwnersCount: 0,
  isViewerDelegateOfLeaders: false,
  setDelegationOwners: (owners) => {
    const delegationOwnersCount = Object.keys(owners).length;

    set({
      delegationOwners: owners,
      delegationOwnersCount,
      isViewerDelegateOfLeaders: delegationOwnersCount > 1,
    });
  },
}));
